const createSearchParams = (params) => {
  const search_params = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    search_params.append(key, value);
  });

  return search_params;
}

const createDestinationUrl = (search_params_Str, pathname) => {
  return {
    pathname: pathname,
    search: search_params_Str
  }
}

const createRiskUrl = (risk, planId) => {
  const searchTerm = risk.unwanted_event ? risk.unwanted_event : risk.hazard;
  const columnName = risk.unwanted_event ? "unwanted_event" : "hazard";
  const params = {
    search_term: searchTerm,
    column_name: columnName,
    show_search_fields: true
  }
  const searchParamsStr = createSearchParams(params).toString();
  const pathName = `/plan/${planId}`
  return createDestinationUrl(searchParamsStr, pathName);
}

export {
  createSearchParams,
  createDestinationUrl,
  createRiskUrl
};


// WEBPACK FOOTER //
// ./src/helpers/url_helpers.js